const NotificationPositionEnum = {
    DEFAULT: 'default',
    CENTER: 'center'
}

export default NotificationPositionEnum;